
export const isTokenObject=(token,type)=>
typeof token==="object"&&token!==null&&token.type===type;